export default __webpack_public_path__ + "static/media/over-axle.9a1fb070.svg";